/**
 * @description: 订单详情
 * @author: hwx
 */
<template>
	<div class="order-detail-wrap">
		<div class="page-tit">订单详情</div>
		<div class="odw-sub-tit clearfix">基本信息
			<div class="col-md-2 pull-right" v-show="theOdw.type == '2' && theOdw.notice_status == '2'">
				<button type="button" class="btn btn-flat btn-middle btn-orange" @click="odwReopenClick">重新开房</button>
			</div>
		</div>
		<div class="row" v-if="theOdw.pay_platform==7">
			<div class="col-md-5">
				<label class="col-md-3">订单序号：</label>
				<span class="col-md-9">{{theOdw.no}}</span>
				<label class="col-md-3">订单单号：</label>
				<span class="col-md-9">{{theOdw.id}}</span>
				<label class="col-md-3">赠送人：</label>
				<span class="col-md-9">{{theOdw.admin_name}}</span>
				<label class="col-md-3">下单时间：</label>
				<span class="col-md-9">{{theOdw.timestamp}}</span>
				<label class="col-md-3">赠送门店：</label>
				<span class="col-md-9">{{theOdw.shop_name}}-{{theOdw.room_name}}</span>
				<label class="col-md-3" v-show="theOdw.pay_platform==8">团购平台：</label>
				<span class="col-md-9" v-show="theOdw.pay_platform==8">{{theOdw.group_buying_type}}</span>
				<label class="col-md-3" v-show="theOdw.pay_platform==8">团购券：</label>
				<span class="col-md-9" v-show="theOdw.pay_platform==8" v-for="(groupitem, index) in theOdw.group_buying_id" :key="index">{{groupitem}}</span>
			</div>
			<div class="col-md-5">
				<label class="col-md-3">实收金额：</label>
				<span class="col-md-9">{{theOdw.actual_pay}}元</span>
				<label class="col-md-3" v-if="theOdw.reward_value>0">优惠券金额：</label>
				<span class="col-md-9" v-if="theOdw.reward_value>0">{{theOdw.reward_value}}元</span>
				<label class="col-md-3">赠送金额：</label>
				<span class="col-md-9">{{theOdw.present_amount}}元</span>
				<label class="col-md-3">支付状态：</label>
				<span class="col-md-9">{{theOdw.status_show}}</span>
				<label class="col-md-3">支付类型：</label>
				<span class="col-md-9">{{theOdw.pay_platform_show}}</span>
				<label class="col-md-3">订单类型：</label>
				<span class="col-md-9">{{theOdw.type_show}}</span>
			</div>
		</div>
		<div class="row" v-else-if="theOdw.pay_platform == 9">
			<div class="col-md-5">
				<label class="col-md-3">订单序号：</label>
				<span class="col-md-9">{{theOdw.no}}</span>
				<label class="col-md-3">订单单号：</label>
				<span class="col-md-9">{{theOdw.id}}</span>
				<label class="col-md-3">兑换人：</label>
				<span class="col-md-9">{{theOdw.user_name}}</span>
				<label class="col-md-3">下单时间：</label>
				<span class="col-md-9">{{theOdw.timestamp}}</span>
				<label class="col-md-3">兑换包厢：</label>
				<span class="col-md-9">{{theOdw.shop_name}}-{{theOdw.room_name}}</span>
			</div>
			<div class="col-md-5">
				<label class="col-md-3">实收金额：</label>
				<span class="col-md-9">{{theOdw.actual_pay}}元</span>
				<label class="col-md-3">兑换金额：</label>
				<span class="col-md-9">{{theOdw.convert_amount}}元</span>
				<label class="col-md-3">消费金额：</label>
				<span class="col-md-9">{{theOdw.amount}}元</span>
				<label class="col-md-3">支付状态：</label>
				<span class="col-md-9">{{theOdw.status_show}}</span>
				<label class="col-md-3">支付类型：</label>
				<span class="col-md-9">{{theOdw.pay_platform_show}}</span>
				<label class="col-md-3">订单类型：</label>
				<span class="col-md-9">{{theOdw.type_show}}</span>
			</div>
		</div>
		<div class="row" v-else-if="theOdw.pay_platform == 13">
			<div class="col-md-5">
				<label class="col-md-3">订单序号：</label>
				<span class="col-md-9">{{theOdw.no}}</span>
				<label class="col-md-3">订单单号：</label>
				<span class="col-md-9">{{theOdw.id}}</span>
				<label class="col-md-3">兑换人：</label>
				<span class="col-md-9">{{theOdw.user_name}}</span>
				<label class="col-md-3">下单时间：</label>
				<span class="col-md-9">{{theOdw.timestamp}}</span>
				<label class="col-md-3">兑换包厢：</label>
				<span class="col-md-9">{{theOdw.shop_name}}-{{theOdw.room_name}}</span>
				<label class="col-md-3">来源：</label>
				<span class="col-md-9">{{theOdw.pay_scene_type}}</span>
			</div>
			<div class="col-md-5">
				<label class="col-md-3">订单类型：</label>
				<span class="col-md-9">{{theOdw.type_show}}</span>
				<label class="col-md-3">支付类型：</label>
				<span class="col-md-9">{{theOdw.pay_platform_show}}</span>
				<label class="col-md-3">兑换积分：</label>
				<span class="col-md-9">{{theOdw.payment_amount}}积分</span>
				<label class="col-md-3">支付状态：</label>
				<span class="col-md-9">{{theOdw.status_show}}</span>
			</div>
		</div>
		<div class="row" v-else>
			<div class="col-md-5">
				<label class="col-md-3">订单序号：</label>
				<span class="col-md-9">{{theOdw.no}}</span>
				<label class="col-md-3">订单单号：</label>
				<span class="col-md-9">{{theOdw.id}}</span>
				<label class="col-md-3">客户昵称：</label>
				<span class="col-md-9">{{theOdw.user_name}}</span>
				<label class="col-md-3" v-show="theOdw.type != '5'">套餐名称：</label>
				<span class="col-md-9" v-show="theOdw.type != '5'">{{theOdw.title}}</span>
				<label class="col-md-3">下单时间：</label>
				<span class="col-md-9">{{theOdw.timestamp}}</span>
				<label class="col-md-3">消费门店：</label>
				<span class="col-md-9">{{theOdw.shop_name}}-{{theOdw.room_name}}</span>
				<label class="col-md-3" v-if="theOdw.type==5">消费时长：</label>
				<span class="col-md-9" v-if="theOdw.type==5">{{theOdw.total_time}}</span>
				<label class="col-md-3" v-show="theOdw.status==4">退款金额：</label>
				<span class="col-md-9" v-show="theOdw.status==4">{{theOdw.refund_amount}}</span>
				<label class="col-md-3" v-show="theOdw.status==4">退款原因：</label>
				<span class="col-md-9" v-show="theOdw.status==4" style="word-wrap:break-word;">{{theOdw.refund_reason}}</span>
				<label class="col-md-3" v-show="theOdw.pay_platform==8">团购平台：</label>
				<span class="col-md-9" v-show="theOdw.pay_platform==8">{{theOdw.group_buying_type}}</span>
				<label class="col-md-3" v-show="theOdw.pay_platform==8">团购券：</label>
				<span class="col-md-9" v-show="theOdw.pay_platform==8" v-for="(groupitem, index) in theOdw.group_buying_id" :key="index">{{groupitem}}</span>
			</div>
			<div class="col-md-5">
				<label class="col-md-3">实收金额：</label>
				<span class="col-md-9 text-red">{{theOdw.actual_pay}}元</span>
				<label class="col-md-3">消费金额：</label>
				<span class="col-md-9">{{theOdw.amount}}元</span>
				<label class="col-md-3" v-if="theOdw.reward_value>0">优惠券金额：</label>
				<span class="col-md-9" v-if="theOdw.reward_value>0">{{theOdw.reward_value}}元</span>
				<label class="col-md-3" v-if="theOdw.pay_platform==11">免单金额：</label>
				<span class="col-md-9" v-if="theOdw.pay_platform==11">{{theOdw.present_amount}}元</span>
				<label class="col-md-3" v-show="theOdw.pay_platform==4">收<i style="width: 29px;display: inline-block;"></i>现：</label>
				<span class="col-md-9" v-show="theOdw.pay_platform==4">{{theOdw.payment_amount}}元</span>
				<label class="col-md-3" v-show="theOdw.pay_platform==4">找<i style="width: 29px;display: inline-block;"></i>零：</label>
				<span class="col-md-9" v-show="theOdw.pay_platform==4">{{theOdw.change_amount}}元</span>
				<label class="col-md-3" v-if="theOdw.type==5">低消金额：</label>
				<span class="col-md-9" v-if="theOdw.type==5">{{theOdw.min_consumption}}</span>
				<label class="col-md-3">支付状态：</label>
				<span class="col-md-9">{{theOdw.status_show}}</span>
				<label class="col-md-3">支付类型：</label>
				<span class="col-md-9">{{theOdw.pay_platform_show}}</span>
				<label class="col-md-3">订单类型：</label>
				<span class="col-md-9">{{theOdw.type_show}}</span>
			</div>
		</div>
		<div class="row odw-top-dash" v-if="theOdw.shopping_guide_name!=''">
			<div class="col-md-5">
				<label class="col-md-3">导购员工：</label>
				<span class="col-md-9">{{theOdw.shopping_guide_name}}</span>
			</div>
		</div>
		<div class="row odw-top-dash">
			<div class="col-md-5">
				<label class="col-md-3">会员卡：</label>
				<span class="col-md-9">{{theOdw.vip_card}}</span>
			</div>
			<div class="col-md-5" v-if="theOdw.before_order_id!=''">
				<label class="col-md-3">已转房：</label>
				<span class="col-md-9">{{theOdw.change_room_msg}}</span>
			</div>
		</div>
		<div class="row">
			<div class="col-md-5">
				<label class="col-md-3">支付人：</label>
				<span class="col-md-9">{{theOdw.pay_user}}</span>
			</div>
			<div class="col-md-5">
				<label class="col-md-3">来源：</label>
				<span class="col-md-9">{{theOdw.pay_scene_type}}</span>
			</div>
		</div>
		<div class="row odw-bottom-dash">
			<div class="col-md-5">
				<label class="col-md-3">备注：</label>
				<span class="col-md-9" v-html="theOdw.remark"></span>
			</div>
			<div class="col-md-5" v-if="theOdw.type==5">
				<label class="col-md-3">修改原因：</label>
				<span class="col-md-9">{{theOdw.alter_timing_reason}}</span>
			</div>
			<div class="col-md-5" v-if="theOdw.type!=5 && theOdw.before_order_id!=''">
				<label class="col-md-3">转房前实收：</label>
				<span class="col-md-9">{{theOdw.before_payment}}</span>
			</div>
		</div>
		<div class="row odw-bottom-dash" v-if="theOdw.alter_timing_reason && theOdw.alter_timing_reason != ''">
			<div class="col-md-5">
				<label class="col-md-3">经理实收原因：</label>
				<span class="col-md-9">{{theOdw.alter_timing_reason}}</span>
			</div>
		</div>
		<div class="row odw-pay-log" v-if="theOdw.pay_platform==14">
			<div class="odw-sub-tit">付款记录</div>
			<ul>
				<li class="clearfix" v-for="(item, index) in odw_pay_info" :key="index">
					<div class="col-md-5">{{item.create_time}}</div>
					<div class="col-md-5">{{item.pay_platform}}：￥{{item.actual_pay}}</div>
				</li>
			</ul>
		</div>

		<!--结束-->
		<div class="odw-sub-tit" style="margin-bottom: 30px;">消费商品</div>
		<div class="table-responsive" style="padding: 0;margin-bottom:30px">
			<table class="table table-bordered table-hover" data-pagination="true" ref="odw_pay_goods"></table>
		</div>
		<div class="row odw-refund">
			<div class="odw-sub-tit" style="margin-bottom: 30px;">退货退款操作日志</div>
			<div class="table-responsive" style="padding: 0; margin-bottom:30px">
				<table class="table table-bordered table-hover" data-pagination="true" ref="odw_refund_log"></table>
			</div>
		</div>
		<div>
			<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="$emit('backOdwPre')">返回</button>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: 'order_manage',
		data() {
			return {
				theOdw: {
					type: Object
				},
				odw_pay_info: [],
				odw_goods_list: [],
				odw_refund_list: [],
				show_vip_shareholder_bonus: false, // 显示分红数据
			}
		},
		mounted: function() {},
		methods: {
			// 获取订单详情 (2022-03-30新增vip_shareholder_bonus参数：是否查找显示分红数据)
			getOdwDetail: function(id, vip_shareholder_bonus) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id,
							"vip_shareholder_bonus": vip_shareholder_bonus || ''
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Order/getDetail",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.theOdw = data.response.result.order_info;
							_this.theOdw.remark = _this.theOdw.remark.replace(/\n/g, '<br>');
							_this.odw_pay_info = data.response.result.pay_info;
							_this.odw_goods_list = data.response.result.goods_info;
							_this.odw_refund_list = data.response.result.refund_info;
							if (!!vip_shareholder_bonus) {
								_this.show_vip_shareholder_bonus = true
							}
							_this.initOdwGoods();
							if(_this.odw_refund_list.length == 0) {
								$('.odw-refund').hide();
							} else {
								_this.initOdwRefund();
								$('.odw-refund').show();
							}
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 点击重新开房
			odwReopenClick: function() {
				let _this = this;
				layer.confirm("确定重新开房吗？", {
					btn: ['确定', '取消'], //按钮
				}, function() {
					_this.odwReopenRoom(_this.theOdw.id);
				});
			},
			// 重新开房
			odwReopenRoom: function(id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Order/reOpenRoom",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						layer.closeAll();
						if(data.response.result_code == "true") {
							layer.msg("重新开房成功！");
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.closeAll();
						layer.msg("出错啦");
					}
				});
			},
			// 初始化消费商品表格
			initOdwGoods: function() {
				let _this = this;
				$(_this.$refs.odw_pay_goods).bootstrapTable("destroy");
				$(_this.$refs.odw_pay_goods).bootstrapTable({
					pagination: false,
					columns: [{
						width: "3%",
						formatter: function(value, row) {
							return '';
						}
					}, {
						field: "goods_name",
						title: "商品名称",
						width: '25%',
						align: 'left',
						formatter: function(value, row, index) {
							return '<p>'+ row.goods_name +'</p>' + '<span style="color: #B1B1B1;">'+ row.flavors +'</span>';
						}
					}, {
						field: "quantity",
						title: "商品数量",
						width: '25%',
						formatter: function(value, row, index) {
							return row.quantity + row.goods_unit_name;
						}
					}, {
						field: "actual_amount",
						title: "商品价格",
						width: '25%'
					},{
						field: "vip_shareholder_bonus",
						title: "分红金额",
						width: '15%',
					}, {
						field: 'state1',
						width: '10%',
						align: 'left',
						formatter: function(value, row, index) {
							if(row.detail.length > 0) {
								return "<a href='javascript:' class=\"detail-icon\" ><i class=\"glyphicon glyphicon-plus icon-plus\"></i></a>";
							} else {
								return '';
							}
						}
					}],
					icons: {
						paginationSwitchDown: 'glyphicon-collapse-down icon-chevron-down',
						paginationSwitchUp: 'glyphicon-collapse-up icon-chevron-up',
						refresh: 'glyphicon-refresh icon-refresh',
						toggle: 'glyphicon-list-alt icon-list-alt',
						columns: 'glyphicon-th icon-th',
						detailOpen: 'glyphicon-plus icon-plus',
						detailClose: 'glyphicon-minus icon-minus'
					},
					data: _this.odw_goods_list,
					// 注册加载子表的事件
					onExpandRow: function (index, row, $detail) {
						_this.initOdwSubGoods(index, row, $detail);
					}

				});
				if (_this.show_vip_shareholder_bonus == false) {
					console.log(_this.show_vip_shareholder_bonus)
					$(_this.$refs.odw_pay_goods).bootstrapTable('hideColumn', 'vip_shareholder_bonus')
				}
			},
			initOdwSubGoods: function(index, row, $detail) {
				let str = '';
				if(row.detail.length > 0) {
					'<p>'+ row.goods_name +'</p>' + '<span style="color: #B1B1B1;">'+ row.flavors +'</span>'

					$.each(row.detail, function(k, v) {
						str += '<li class="clearfix" style="line-height: 30px;"><div style="float: left; width: 33%; text-align: left;"><p style="margin: 0;">'+ v.goods_name +'</p><span style="color: #B1B1B1;">'+ v.flavors +'</span></div><div style="float: left; width: 33%">'+ v.quantity + v.goods_unit_name +'</div><div style="float: left; width: 33%">0</div></li>';
					});
					$detail.html('<ul style="width: 78%; padding-left: 4%;">'+ str +'</ul>');
				} else {
					$detail.html('<div style="float: left; width: 20%">没有找到匹配的记录</div>');
				}
			},
			// 初始化退货退款表格
			initOdwRefund: function() {
				let _this = this;
				$(_this.$refs.odw_refund_log).bootstrapTable("destroy");
				$(_this.$refs.odw_refund_log).bootstrapTable({
					pagination: false,
					columns: [{
						field: "time",
						title: "操作时间",
						width: '30%'
					}, {
						field: "admin_name",
						title: "操作人",
						width: '30%'
					}, {
						field: "detail",
						title: "详情",
						width: '40%',
						formatter: function(value, row) {
							return '<p>退款：'+row.refund_amount+'元</p><p>退货：'+row.goods+'</p><p>退款原因：'+row.refund_reason+'</p>'
						}
					}],
					data: _this.odw_refund_list
				});
			},
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.order-detail-wrap {
		.odw-sub-tit {
			margin: 30px 0 30px 0px;
			font-size: 18px;
		}
		.col-md-5 {
			padding-left: 0;
			font-size: 14px;
			>label {
				height: 40px;
				line-height: 40px;
				padding: 0;
				margin-bottom: 0px;
			}
			>span {
				min-height: 40px;
				padding-left: 0;
				line-height: 40px;
			}
		}
		.odw-top-dash {
			border-top: 1px dashed #e4e4e4;
		}
		.odw-bottom-dash {
			border-bottom: 1px dashed #e4e4e4;
		}
		.odw-pay-log {
			li {
				line-height: 30px;
			}
		}

		.glyphicon-plus:before {
			content: '';
			display: block;
			width: 11px;
			height: 20px;
			background: url(../assets/images/order_manage/turn_down.png) left center no-repeat;
			cursor: pointer;
		}
		.glyphicon-minus:before {
			content: '';
			display: block;
			width: 11px;
			height: 20px;
			background: url(../assets/images/order_manage/turn_top.png) left center no-repeat;
			cursor: pointer;
		}
	}
</style>